module.exports = __webpack_public_path__ + "img/medical-dental.94eab72c.jpg";